import { createAsyncThunk } from '@reduxjs/toolkit';

import { KhodroHttpGetService } from 'Feature/Khodro/ShakhsSales/Services/KhodroHttpService';
import { _apiPathManagerConfig } from 'Shared/ApiPaths/ApiPathManagerSetup';

import IGetAllBrandHaQuery from '../Queries/IGetAllBrandHaByNoeVasilehNaghliehQuery';

export const getAllBrandHaByNoeVasilehNaghlieh = createAsyncThunk(
  'Brand/GetAllBrandHaByNoeVasilehNaghlieh',
  async (query: IGetAllBrandHaQuery) => {
    return await KhodroHttpGetService({
      url: `${_apiPathManagerConfig?.Khodro.Brand.GetAllBrandHaByNoeVasilehNaghlieh}`,
      params: query,
    });
  }
);
